var _path, _path2, _path3, _ellipse, _rect, _rect2, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5558 40.8041L30.5684 35.7455L50.3674 55.5445L45.3088 57.5571L28.5558 40.8041Z",
    fill: "url(#paint0_linear_45_1430)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3547 52.9881L24.9111 48.4734L37.6391 61.2014L33.1245 63.7578L22.3547 52.9881Z",
    fill: "url(#paint1_linear_45_1430)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3462 16.6537L16.0723 70.0402L69.4589 47.7664",
    stroke: "url(#paint2_linear_45_1430)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.9028,
    cy: 32.21,
    rx: 22,
    ry: 9,
    transform: "rotate(45 53.9028 32.21)",
    stroke: "url(#paint3_linear_45_1430)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56.9438,
    y: 24.0263,
    width: 8,
    height: 8,
    transform: "rotate(93.1673 56.9438 24.0263)",
    fill: "url(#paint4_linear_45_1430)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.3799,
    y: 35.8874,
    width: 3.42524,
    height: 3.42524,
    transform: "rotate(-145.866 66.3799 35.8874)",
    fill: "url(#paint5_linear_45_1430)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4976,
    y: 9.88376,
    width: 5.07954,
    height: 5.07954,
    transform: "rotate(-3.57284 59.4976 9.88376)",
    fill: "url(#paint6_linear_45_1430)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_1430",
    x1: 46.7511,
    y1: 56.8785,
    x2: 42.3035,
    y2: 59.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_1430",
    x1: 34.4303,
    y1: 62.9429,
    x2: 29.8549,
    y2: 65.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_1430",
    x1: 45.5795,
    y1: 38.2771,
    x2: 6.55161,
    y2: 47.3744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_1430",
    x1: 52.0591,
    y1: 25.9196,
    x2: 49.0111,
    y2: 41.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_1430",
    x1: 64.4828,
    y1: 29.6269,
    x2: 60.3532,
    y2: 32.7381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_45_1430",
    x1: 69.6077,
    y1: 38.2853,
    x2: 67.8396,
    y2: 39.6174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_45_1430",
    x1: 64.2843,
    y1: 13.4398,
    x2: 61.6623,
    y2: 15.4153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#4CD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2FF29"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.a0062cdee30af561226db836a23fcbc4.svg";
export { ForwardRef as ReactComponent };